export default {"src":"/_next/static/media/discord-logo.388a742c.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};